import React, {Component} from 'react';
import {connect} from 'react-redux';
import {storeContractorNonEngineer} from '../../actions';
import NewNonEngineer from '../shared/NewNonEngineer';


class NewNonEngineerContainer extends Component {
    render() {
        return <NewNonEngineer {...this.props}/>;
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        belongsTo: state.me.contractor_id
    }
};
export default connect(mapStateToProps, {
    storeNonEngineer: storeContractorNonEngineer
})(NewNonEngineerContainer);


// WEBPACK FOOTER //
// ./resources/assets/js/components/contractor/NewNonEngineerContainer.js